export const inputs = {
  dateTravelRange: {
    type: "dateRange",
    name: "dateTravelRange",
    label: "Выберите даты",
    wrapClass: "input-box",
  },
}